import script from "./Skeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./Skeleton.vue?vue&type=script&setup=true&lang=js"

import "./Skeleton.vue?vue&type=style&index=0&id=19036c0a&lang=scss"

const __exports__ = script;

export default __exports__